// extracted by mini-css-extract-plugin
export default {"Sections":"Sections_Sections__Vtw6x","section":"Sections_section__P14h9","image":"Sections_image__nDNwq","content":"Sections_content__BoLgD"};